<form [formGroup]="productForm" class="product-form">
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Vendor Name</mat-label>
      <input matInput formControlName="vendorName" placeholder="Enter vendor name" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Product Name</mat-label>
      <input matInput formControlName="productName" placeholder="Enter product name" />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Vendor Slug</mat-label>
      <input matInput formControlName="vendorSlug" placeholder="Enter vendor slug" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Product Slug</mat-label>
      <input matInput formControlName="productSlug" placeholder="Enter product slug" />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Stripe Product ID</mat-label>
      <input matInput formControlName="stripeProductId" placeholder="Enter Stripe product ID" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Stripe Vendor</mat-label>
      <input matInput formControlName="stripeVendor" placeholder="Enter Stripe vendor" />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Metadata (JSON)</mat-label>
      <textarea
        matInput
        formControlName="metadata"
        placeholder='Enter metadata as JSON (e.g., {"key": "value"})'
        rows="6"
        (blur)="formatJsonOnBlur('metadata')"
      ></textarea>
      <mat-hint>
        Payroll Admin display overrides: <code>payrollAdminVendorName</code> and
        <code>payrollAdminProductName</code> and <code>payrollAdminDetailsUrl</code> and
        <code>payrollAdminLogoUrl</code>
      </mat-hint>
      <mat-error *ngIf="productForm.get('metadata')?.hasError('invalidJson')">
        Invalid JSON format
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Feed Config (JSON)</mat-label>
      <textarea
        matInput
        formControlName="feedConfig"
        placeholder='Enter feed config as JSON (e.g., {"key": "value"})'
        rows="6"
        (blur)="formatJsonOnBlur('feedConfig')"
      ></textarea>
      <mat-error *ngIf="productForm.get('feedConfig')?.hasError('invalidJson')">
        Invalid JSON format
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="saveProduct()"
      [disabled]="!productForm.valid"
    >
      Save Product
    </button>
    <button mat-button type="button" (click)="resetForm()">Reset</button>
  </div>
</form>
